import angular from "angular";

angular
    .module('app')
    .component('clientsFieldsControl', {
        template: require('./clients-fields-control.html'),
        controller: ['$uibModal', '$http', 'notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&',
        }
    });

function controller($uibModal, $http, notifier) {

    const $ctrl = this;

    $ctrl.$onInit = () => {
        $ctrl.organization = $ctrl.resolve.organization;

        $ctrl.fields = $ctrl.resolve.fields;

        $ctrl.selectedFields = $ctrl.resolve.selectedFields.map(v => {
            return {
                field_id: v.id,
                field_title: v.title,
                custom_title: v.pivot.custom_title,
                edit_on_directory: !!v.pivot.edit_on_directory,
                edit_on_booking: !!v.pivot.edit_on_booking,
                required_on_booking: !!v.pivot.required_on_booking,
                default_value: v.pivot.default_value,
            }
        });
    };

    $ctrl.openFieldForm = (editingField, editingFieldInd) => {
        $uibModal.open({
            component: 'attachFieldForm',
            resolve: {
                fields() {
                    return $ctrl.fields;
                },
                selectedFields() {
                    return $ctrl.selectedFields;
                },
                editingField() {
                    return editingField;
                }
            }
        }).result.then(
            res => {
                if (editingField) {
                    editingField.custom_title = res.custom_title;
                    editingField.default_value = res.default_value;
                    editingField.edit_on_directory = res.edit_on_directory;
                    editingField.edit_on_booking = res.edit_on_booking;
                    editingField.required_on_booking = res.required_on_booking;
                } else {
                    $ctrl.selectedFields.push(res);
                }
            }
        );
    };

    $ctrl.delField = (field, ind) => {
        this.selectedFields.splice(ind, 1);
    };

    $ctrl.submit = () => {
        $ctrl.loading = true;

        $http
            .post(`/control-panel/organizations/${$ctrl.organization.id}/sync-fields`, {fields: $ctrl.selectedFields})
            .then(res => {
                notifier.successNotify('Успешно обновлено');

                $ctrl.close({$value: $ctrl.selectedFields});
            })
            .catch(err => {
                notifier.errorResponseNotify(err);
            })
            .finally(() => {
                $ctrl.loading = false;
            });
    };
}


// WEBPACK FOOTER //
// ./resources/assets/modules/components/clients-fields-control/clients-fields-control.js